import { TextInput } from 'components/Inputs/';
import React, { useEffect, useState } from 'react';
import { FlexCol, FlexRow } from 'components/Layout/';
import { Message } from 'components/Item/Quantity/styles';
import { ReactComponent as ArrowIcon } from 'icons/tick.svg';
import { CancelButton, RoundButton } from 'components/Buttons/';

export function Quantity({ id, stock, onClose, onSubmit, maxQuantity }) {
  const [message, setMessage] = useState('');
  const [quantity, setQuantity] = useState(stock);

  function onStockChange(e) {
    const { value } = e.currentTarget;
    setQuantity(value ? Number(value) : '');
  }

  function onSubmitClick() {
    if (!quantity) {
      setMessage('Quantity is required');
    } else if (quantity > maxQuantity) {
      setMessage(`Quantity cannot exceed ${maxQuantity}`);
    } else {
      setMessage('');
      onSubmit({ id, quantity });
    }
  }

  useEffect(() => {
    setQuantity(stock);
  }, [stock]);

  return (
    <>
      <FlexRow>
        <FlexCol flexWidth={6}>
          <TextInput
            isRequired
            name="quantity"
            value={quantity}
            inputId="quantity"
            caption="Quantity"
            inputType="number"
            onChange={onStockChange}
            placeholder="Enter quantity"
            description={`How many pieces do you have (max ${maxQuantity})`}
          />
        </FlexCol>
      </FlexRow>
      {message ? <Message>{message}</Message> : null}
      <FlexRow className="modal-buttons-row">
        <FlexCol flexWidth={4}>
          <RoundButton
            caption="Save"
            icon={<ArrowIcon />}
            className="save-button"
            onClick={onSubmitClick}
          />
        </FlexCol>
        <FlexCol flexWidth={4}>
          <CancelButton onClick={onClose} />
        </FlexCol>
      </FlexRow>
    </>
  );
}
